const h1class = 'text-3xl tracking-wide font-bold max-w';
const h2class = 'text-xl tracking-wide font-bold max-w pt-3';
export default () => (
    <div className="text-justify m-2">
        <h1 className={h1class}>Impressum</h1>

        <h2 className={h2class}>Diensteanbieter</h2>
        <p>Felix Köcher</p>
        <p>Im Hohlweg 6B</p>
        <p>54518 Hupperath</p>
        <p>Deutschland</p>

        <h2 className={h2class}>Kontaktmöglichkeiten</h2>
        <p>E-Mail-Adresse: <a className="underline" href="mailto:contact@cook-a-geddon.de">contact@cook-a-geddon.de</a></p>
        <p>Telefon: +49 176 57987142</p>

        <h2 className={h2class}>Audiovisuelle Mediendienste</h2>
        <p>Sitzland: Deutschland</p>
        <p>
            Zuständige Regulierungs-, bzw. Aufsichtsbehörde: Landesanstalt für Medien NRW, <a className="underline" href="https://www.medienanstalt-nrw.de/" target="_blank">https://www.medienanstalt-nrw.de/</a>
        </p>

        <h2 className={h2class}>Online-Streitbeilegung (OS)</h2>
        <p>
            Online-Streitbeilegung: Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit, die Sie unter <a className="underline" href="https://ec.europa.eu/consumers/odr/" target="_blank">https://ec.europa.eu/consumers/odr/</a> finden. Verbraucher haben die Möglichkeit, diese Plattform für die Beilegung ihrer Streitigkeiten zu nutzen.
        </p>

        <h2 className={h2class}>Social Media und andere Onlinepräsenzen</h2>
        <p>
            Dieses Impressum gilt auch für die folgenden Social-Media-Präsenzen und Onlineprofile:
        </p>
        <p>
            <a className="underline" href="https://www.instagram.com/cook_a_geddon/" target="_blank">https://www.instagram.com/cook_a_geddon/</a>
        </p>

        <h2 className={h2class}>Haftungs- und Schutzrechtshinweise</h2>
        <p>
            <strong>Urheberrechte und Markenrechte</strong>:
            Alle auf dieser Website dargestellten Inhalte, wie Texte, Fotografien, Grafiken,
            Marken und Warenzeichen sind durch die jeweiligen Schutzrechte (Urheberrechte, Markenrechte)
            geschützt. Die Verwendung, Vervielfältigung usw. unterliegen unseren Rechten oder den Rechten der
            jeweiligen Urheber bzw. Rechteinhaber.
        </p>
        {/* <p class="seal">
            <a href="https://datenschutz-generator.de/?l=de" title="Rechtstext von Dr. Schwenke -
für weitere Informationen bitte anklicken." target="_blank" rel="noopener noreferrer nofollow">Erstellt mit
            kostenlosem Datenschutz-Generator.de von Dr. Thomas Schwenke</a></p> */}
    </div>
);
